"use client";

import { MATCH_STATUS as STATUS } from "@/contants";
import livescoreGif from "@/assets/images/livescore.gif";
import { formatDateTime } from "@/utils/format";

const Shell = ({ className = "", children }) => (
  <span className={`inline-flex flex-col items-center justify-center  text-[18px] ${className}`}>{children}</span>
);

export default function LiveScoreMatchMinute({
  liveScore,
  status,
  matchTime,
  halfStartTime,
  className = "",
  timeStyle = "desktop",
}) {
  const isMobile = timeStyle === "mobile";
  const isCheckingVar = !!liveScore?.var;
  let matchStatus = "--";
  let currentMinute = null;
  let showMatchTime = false;

  if (isCheckingVar) {
    return (
      <Shell
        className={
          isMobile
            ? `kbv-cs-text-mobile-schedule text-[10px] font-normal leading-[16px] ${className}`
            : `font-medium leading-[inherit] ${className}`
        }
      >
        <span className="kbv-cs-bg-score mb-0.5 h-1.5 w-1.5 animate-pulse rounded-full" />
        <span>VAR</span>
      </Shell>
    );
  }

  const currentStatus =
    liveScore?.status !== undefined ? Number(liveScore.status) : status;

  if (liveScore?.minute !== undefined || liveScore?.currentMinute !== undefined) {
    currentMinute = liveScore?.minute ?? liveScore?.currentMinute;
    showMatchTime = true;
  } else {
    const timeStart =
      liveScore?.halfStartTime ||
      (currentStatus === STATUS.FIRST_HALF ? matchTime : halfStartTime);
    const currentTime = Math.floor(Date.now() / 1000);

    if (timeStart != null && timeStart !== "") {
      const startTimeUnix = !isNaN(Number(timeStart))
        ? Number(timeStart)
        : Math.floor(new Date(timeStart).getTime() / 1000);

      switch (currentStatus) {
        case STATUS.FIRST_HALF:
          showMatchTime = true;
          currentMinute = Math.floor((currentTime - startTimeUnix) / 60);
          if (currentMinute >= 45) {
            currentMinute = `45+${currentMinute - 45}`;
          }
          break;

        case STATUS.SECOND_HALF:
          showMatchTime = true;
          if (!Number.isFinite(Number(timeStart)) || Number(timeStart) <= 0) {
            currentMinute = 45;
            break;
          }
          const secondHalfMinute =
            45 + Math.floor((currentTime - Number(timeStart)) / 60);
          if (!Number.isFinite(secondHalfMinute) || secondHalfMinute < 45) {
            currentMinute = 45;
            break;
          }
          currentMinute = secondHalfMinute;
          if (currentMinute >= 90) {
            currentMinute = `90+${currentMinute - 90}`;
          }
          break;

        case STATUS.EXTRA_TIME:
          showMatchTime = true;
          currentMinute = `ET+${Math.floor((currentTime - startTimeUnix) / 60)}`;
          break;

        case STATUS.HALF_TIME_BREAK:
          matchStatus = "HT";
          break;

        case STATUS.NOT_STARTED:
          showMatchTime = false;
          {
            const { time } = formatDateTime(matchTime);
            matchStatus = time;
          }
          break;

        case STATUS.FINISHED:
          matchStatus = "FT";
          showMatchTime = false;
          break;

        case STATUS.TERMINATED:
          matchStatus = "Huỷ";
          break;

        case STATUS.POSTPONED:
          matchStatus = "Hoãn";
          break;

        case STATUS.INTERRUPTED:
          matchStatus = "Gián Đoạn";
          break;

        default:
          showMatchTime = false;
          break;
      }
    }
  }

  const isLive = [
    STATUS.FIRST_HALF,
    STATUS.SECOND_HALF,
    STATUS.EXTRA_TIME,
    STATUS.HALF_TIME_BREAK,
  ].includes(currentStatus);

  const liveAccentMobile = "kbv-cs-text-score text-[10px] font-bold";
  const liveAccentDesktop = "kbv-cs-text-score font-bold";
  const mobileMuted = "kbv-cs-text-mobile-schedule text-[10px] font-normal leading-[16px]";
  const desktopShell = "font-medium leading-[inherit]";

  const shellClass = isMobile ? `${mobileMuted} ${className}` : `${desktopShell} ${className}`;
  const dotClass = "kbv-cs-bg-score";
  const liveAccent = isMobile ? liveAccentMobile : liveAccentDesktop;

  const minuteBlock =
    showMatchTime && currentMinute !== null ? (
      isLive ? (
        <b className={`${liveAccent} inline-flex items-center gap-0.5`}>
          <img
            src={livescoreGif}
            alt=""
            className="h-2.5 w-25 shrink-0 object-contain  mr-1"
            width={8}
            height={8}
            decoding="async"
            aria-hidden
          />
          {currentMinute}
          <span className="kbv-cs-text-minute-tick animate-blink font-bold">'</span>
        </b>
      ) : (
        <>
          {currentMinute}
          <span className="animate-blink">'</span>
        </>
      )
    ) : (
      <span>{matchStatus}</span>
    );

  return (
    <Shell className={shellClass}>
      <span className="whitespace-nowrap">{minuteBlock}</span>
    </Shell>
  );
}
